import { render } from "./DefaultBadges.vue?vue&type=template&id=6fe68266&ts=true"
import script from "./DefaultBadges.vue?vue&type=script&lang=ts"
export * from "./DefaultBadges.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__